export const NewTechData ={
    name:"NewTechWood",
    img:require("../../../../assets/services/PreviewWood.jpeg"),
    fullDesc:"Conventional wood plastic composites are a thing of the past.\n " +
        "In 2010, NewTechWood began a project to design and formulate the most durable,\n" +
        " most attractive, most fade and scratch resistant,\n" +
        " most beautiful and most reliable composite deck board in the industry: NewTechWood UltraShield®."
};
